/* eslint-disable max-len */

import React, { useState } from 'react'
import Refund from 'SVGPath/refund.svg'
import NoRefund from 'SVGPath/no-refund.svg'
import { arrDepFormatter, fetchRefundStatus, fireClevertapEvent } from 'AccountsUtils'
import Sheet from 'Lib/Sheet'
import {
  CANCEL_CHARGE_NOTE,
  AMEND_CHARGE_NOTE,
  FARE_RULE_ERROR
} from 'AccountsConstants/language/cancellation'
import Overlay from 'Lib/Overlay'
import Modal from 'Lib/Modal'
import FareRules from './FareRules'
import ToolTip from './ToolTip'
import VerticalToolTipBody from './VerticalToolTipBody'
import { SVGComponent } from '.'
import FareRulesDesktop from './FareRulesWidget'
import FareRulesWidgetPwa from './FareRulesWidgetPwa'
import DesktopModal from './UnifiedLogin/Modal'

const RefundBlock = ({ refundStatus, id, first, header, tripId, isPWA, extraClass = '', isEzcancelProBooking, faqs, currency }) => {
  const [fareRulesFlag, setFareRulesFlag] = useState(false)
  const [fareRulesTimelineFlag, setFareRulesTimelineFlag] = useState(false)
  const [fareRulesData, setFareRulesData] = useState(null)
  const [currentFareData, setCurrentFareData] = useState(null)

  const { cancellations, amendments } = faqs || {}
  const onFareRulesClick = (depDate, subHeading, timeZone) => {
    setCurrentFareData(null)
    fireClevertapEvent('fare_rules_clicked', { trip_id: tripId, trip_name: subHeading })

    if (cancellations || amendments) {
      let combinedFareRules
      let fareData
      if (cancellations && cancellations.length > 0) {
        const cancellationCharges = cancellations.filter(
          chrges => {
            return chrges.tag && chrges.tag === 'cancellation_charges' && chrges.faqsChargesTable && chrges.faqsChargesTable.length > 0
          }
        )
        if (cancellationCharges[0]) {
          const currentFare = cancellationCharges[0].faqsChargesTable.filter(
            faqCharges => {
              return faqCharges.flightId === id
            }
          )
          const { departureCity,
            arrivalCity,
            departureTime, flightId,
            fareRules } = currentFare[0] || {}
          const { cancelCharges } = fareRules || {}
          combinedFareRules = { cancelCharges }
          fareData = {
            departureCity,
            arrivalCity,
            departureTime,
            currency,
            flightId
          }
        }
      }
      if (amendments && amendments.length > 0) {
        const amendCharges = amendments.filter(
          chrges => {
            return chrges.tag && chrges.tag === 'amendment_charges' && chrges.faqsChargesTable && chrges.faqsChargesTable.length > 0
          }
        )
        if (amendCharges[0]) {
          const currentAmendFare = amendCharges[0].faqsChargesTable.filter(
            faqCharges => {
              return faqCharges.flightId === id
            }
          )
          const { fareRules } = currentAmendFare[0] || {}
          combinedFareRules.amendCharges = [...fareRules.amendCharges]
        }
      }
      fareData.fareRules = { ...combinedFareRules }
      setCurrentFareData({ fareDetails: { ...fareData } })
      setFareRulesTimelineFlag(true)
    } else if (!fareRulesData) {
      fetchRefundStatus(tripId, true).then(res => {
        fireClevertapEvent('fare-rules_data_fetched', { trip_id: tripId, trip_name: subHeading })
        if (res && res.length > 0) {
          const fareData = res.reduce((init, item) => {
            const newInit = { ...init }
            const { flightId } = item
            newInit[flightId] = item
            return newInit
          }, {})
          setFareRulesData(fareData)
          setCurrentFareData({ fareDetails: fareData[id], depDate, subHeading, timeZone })
          setFareRulesFlag(true)
        }
      }).catch(e => {
        fireClevertapEvent('fare-rules_data_fetch_failed', { trip_id: tripId, trip_name: subHeading, error_code: e.status })
      })
    } else {
      setCurrentFareData({ fareDetails: fareRulesData[id], depDate, subHeading, timeZone })
      setFareRulesFlag(true)
    }
  }

  const fareRuleModalHandler = e => {
    setFareRulesFlag(false)
    const ele = document.getElementsByClassName('zen-body')
    if (ele && ele[0]) {
      ele[0].classList.remove('overflow-hidden')
    }
  }
  const fareRuleTimelineModalHandler = e => {
    setFareRulesTimelineFlag(false)
  }
  return (
    <If condition={isPWA}>
      <React.Fragment>
        {/* <SlideModal
          header="fare rules"
          subHeader={currentFareData && currentFareData.subHeading}
          open={fareRulesFlag && currentFareData}
          onCloseClick={e => fareRuleModalHandler(e)}
        > */}
        <If condition={fareRulesTimelineFlag && currentFareData}>
          <div className="flex flex-middle ml-1 mt-1">

            <Overlay>
              <Modal type="renderProp" bottom={true} className="modal-pwa">
                <FareRulesWidgetPwa
                  data={currentFareData}
                  isRefundFareRule={true}
                  marginTop="mt-0060"
                  onClose={e => fareRuleTimelineModalHandler(e)}
                />
              </Modal>
            </Overlay>
          </div>
        </If>
        <Sheet
          isOpen={fareRulesFlag && currentFareData}
          onClose={e => fareRuleModalHandler(e)}
          title="Fare Rules"
        >
          <div className="p-4 fs-15 bg-white">
            <If condition={currentFareData &&
              Object.keys(currentFareData.fareDetails).length > 0 &&
              (currentFareData.fareDetails.cancelCharges ||
                currentFareData.fareDetails.amendSameFareCharges ||
                currentFareData.fareDetails.amendHigherFareCharges)}
            >
              <div>
                <p className="tt-sentence fs-15 pt-1">cancellation charges</p>
                <FareRules isPWA={isPWA} noOuterBorder={true} data={currentFareData} showArrDest={false} property="cancelCharges" borderBottom={true} />
                <p className={`fs-13 ${isPWA ? '' : 'px-4'} pt-2 c-grey-40`}>{CANCEL_CHARGE_NOTE}</p>
              </div>
              <div>
                <p className="tt-sentence fs-15 pt-4">flight change rules</p>
                <FareRules isPWA={isPWA} noOuterBorder={true} data={currentFareData} showArrDest={false} property="amendSameFareCharges" />
                <p className={`fs-13 ${isPWA ? '' : 'px-4'} pt-2 c-grey-40`}>{AMEND_CHARGE_NOTE}</p>
              </div>
              <Else />
              <p className="pt-2 pl-6 fs-11">{FARE_RULE_ERROR}</p>
            </If>
          </div>
        </Sheet>
        <If condition={isEzcancelProBooking && !isEzcancelProBooking.ezcancel_fare_pro}>
          <div className={`p-4 pr-7 fs-15 flex bg-white flex-between ${extraClass}`}>
            <div className="flex">
              <If condition={refundStatus[id]}>
                <Refund fill="#a7a7aa" />
                <Else />
                <NoRefund fill="#a7a7aa" />
              </If>
              <p className="min-33 pl-2 tt-sentence">{refundStatus[id] ? 'refundable' : 'non-refundable'}</p>
            </div>
            <If condition={refundStatus[id]}>
              <a onClick={() => onFareRulesClick(first.departureDate, header, first.departureAirportTimeZone)} className="fs-15 tt-sentence c-blue">Fare rules</a>
            </If>
          </div>
          <Else />
          <div className={`p-4 fs-15 flex bg-white flex-between ${extraClass}`}>
            <div className="flex">
              <Refund fill="#a7a7aa" />
              <p className="min-33 pl-2 tt-sentence">refundable</p>
            </div>
          </div>
        </If>
      </React.Fragment>
      <Else />
      <If condition={fareRulesTimelineFlag && currentFareData}>
        <div className="flex flex-middle ml-1 mt-1">

          <DesktopModal
            isShowing={fareRulesTimelineFlag}
            overlayClassName="z-70"
            overlayStyle={{ zIndex: 10000 }}
          >
            <div
              className="bg-white br-4 br-4 o-hidden"
              style={{
                width: '710px',
                minHeight: '470px'
              }}
            >
              <div>
                <FareRulesDesktop
                  data={currentFareData}
                  isRefundFareRule={true}
                  onClose={e => fareRuleTimelineModalHandler(e)}
                  marginTop="mt-0010"
                />
              </div>
            </div>

          </DesktopModal>
        </div>
      </If>

      <If condition={isEzcancelProBooking && !isEzcancelProBooking.ezcancel_fare_pro}>
        <div className="flex m-1">
          <If condition={refundStatus[id]}>
            <Refund fill="#a7a7aa" />
            <Else />
            <NoRefund fill="#a7a7aa" />
          </If>
          <p className="min-33 pl-1 tt-sentence pr-1 m-1">{refundStatus[id] ? 'refundable' : 'non-refundable'}</p>
          <If condition={refundStatus[id]}>
            <If condition={cancellations || amendments}>
              <div onClick={() => onFareRulesClick(first.departureDate, header, first.departureAirportTimeZone)}>
                <SVGComponent svgIcon="info_outline" />
              </div>

              <Else />
              <ToolTip
                onOpenCallBack={() => onFareRulesClick(first &&
                  first.departureDate, header, first && first.departureAirportTimeZone)}
                accessingPoint={<SVGComponent svgIcon="info_outline" />}
                toolTipBody={(
                  <If condition={currentFareData}>
                    <VerticalToolTipBody
                      vertical="air"
                      data={{
                        header: arrDepFormatter(first.departureAirport, first.arrivalAirport, 'O'),
                        fare: currentFareData
                      }}
                    />
                  </If>
                )}
              />
            </If>
          </If>
        </div>
        <Else />
        <div className="flex m-1">
          <Refund fill="#a7a7aa" />
          <p className="min-33 pl-1 tt-sentence pr-1 m-1">refundable</p>
        </div>
      </If>
    </If>
  )
}

export default RefundBlock
